class MFRBundle {
  constructor(data) {
    this.$element = $("body");

    this.selectors = {
      product: "[data-bundle-product-card]",
      addButton: "[data-mfr-add-to-bundle]",
      removeButton: "[data-mfr-remove-to-bundle]",
      bundleSection: "[data-mfr-bundle-section]",
      bundler: "[data-mfr-bundler]",
      submit: "[data-mfr-bundler-submit]",
      subscription: '[name="subscription_type"]',
      removeBundleFromCart: "[data-mfr-remove-bundle]",
      limitSwitch: "[data-mfr-limit-switch]",
      limitSwitchWrapper: "[data-mfr-limit-switch-wrapper]",
      productCard: "[data-bundle-product-card]",
      bundlerVisualizer: "[data-mfr-bundler-visualizer]",
      bundlerVisualizerRemove: "[data-mfr-bundler-visualizer-remove]",
      bundlerVisualizerWrapper: "[data-mfr-bundler-visualizer-wrapper]",
      visualizerImage: "[data-mfr-bundler-visualizer-image] img",
      countIndicator: "[data-mfr-count-indicator]",
      countIndicatorWrapper: "[data-mfr-count-indicator-wrapper]",
      progressBar: "[data-mfr-bundler-progress-bar]",
      accentImageContainer: "[data-mfr-bundler-accent-images]",
      progressLabel: ".mix-and-match__bundler .progress-label",
      bundlerContainer: ".mix-and-match__bundler-container",
    };

    window.mfrBundle = [];
    this.limit = data.limit ?? 0;

    this.maxPerProduct = data.maxPerProduct;
    this.minimumProducts = data.minimumProducts ?? 0;
    this.updateLimit();

    this.init();
  }

  init() {
    this.$progressBar = this.$element.find(this.selectors.progressBar);
    this.$bundleSection = this.$element.find(this.selectors.bundleSection);
    this.$bundler = this.$element.find(this.selectors.bundler);
    this.$bundlerContainer = this.$element.find(
      this.selectors.bundlerContainer
    );
    this.$progressLabel = $(this.selectors.progressLabel);
    this.$gift = window.bundleDiscount;

    if (this.$bundleSection.length) this.initBundler();

    $(document).on(
      "click",
      this.selectors.product,
      this.__handleAddButtonClick.bind(this)
    );
    $(document).on(
      "click",
      this.selectors.countIndicatorWrapper,
      this.__handleRemoveButtonClick.bind(this)
    );
    $(document).on(
      "click",
      this.selectors.bundlerVisualizerRemove,
      this.__handleVisualizerRemove.bind(this)
    );
    $(document).on(
      "click",
      this.selectors.removeBundleFromCart,
      this.__handleRemoveBundleFromCart.bind(this)
    );
    $(document).on(
      "click",
      this.selectors.limitSwitch,
      this.__handleLimitSwitchClick.bind(this)
    );
    this.$bundlerContainer.on("click", this.__handleBundlerClick.bind(this));
  }

  __handleAddButtonClick(e) {
    e.preventDefault();

    if (this.limit <= this.getBundleQuantity() && this.limit > 0) return;
    if (
      $(e.target).hasClass("mix-and-match__product-actions") ||
      $(e.target).closest(".mix-and-match__product-actions").length > 0
    )
      return;

    const button = $(e.currentTarget).find(this.selectors.addButton);
    const variantID = $(button).attr("data-mfr-add-to-bundle");
    const price = $(button).data("mfr-bundle-price");
    const selling_plan = $(button).data("mfr-bundle-selling_plan");
    const quantity = 1;
    // const visualizerImage = $( e.currentTarget ).closest( this.selectors.productCard ).find( this.selectors.visualizerImage ).clone();

    // BRENDAN –––––– show indicator and remove button
    const parent = $(e.currentTarget);
    const indicatorWrapper = parent.find(this.selectors.countIndicatorWrapper);
    const indicator = parent.find(this.selectors.countIndicator);

    indicatorWrapper.css("display", "flex");
    indicator.text(parseInt(indicator.text()) + 1);

    $(document).trigger("mfr-bundle:product-added", {
      element: $(e.currentTarget),
      id: variantID,
    });

    // BRENDAN END

    window.mfrBundle.push({
      id: variantID,
      quantity: quantity,
      price: price,
      selling_plan: selling_plan,
      // visualizerImage: visualizerImage
    });

    this.addVisualizerAccentImage(variantID);

    $(document).trigger("mfr-bundle:bundle-changed", [
      {
        add: variantID,
      },
    ]);
  }

  __handleVisualizerRemove(e) {
    const index = $(e.currentTarget).data("mfr-bundler-visualizer-remove");
    const productID = window.mfrBundle[index].id;

    mfrBundle.splice(index, 1);
    $(document).trigger("mfr-bundle:bundle-changed");

    const parent = $(`[data-mfr-add-to-bundle="${productID}"]`).closest(
      this.selectors.productCard
    );
    const indicatorWrapper = parent.find(this.selectors.countIndicatorWrapper);
    const indicator = parent.find(this.selectors.countIndicator);

    indicator.text(parseInt(indicator.text()) - 1);
    if (parseInt(indicator.text()) <= 0) indicatorWrapper.hide();

    this.removeVisualizerAccentImage(productID);
  }

  __handleRemoveButtonClick(e) {
    e.preventDefault();

    // BRENDAN –––––– reset and hide indicator and remove button
    const parent = $(e.currentTarget).closest(this.selectors.productCard);
    const indicatorWrapper = parent.find(this.selectors.countIndicatorWrapper);
    const indicator = parent.find(this.selectors.countIndicator);
    const button = $(e.currentTarget).find(this.selectors.removeButton);

    const variantID = $(button).attr("data-mfr-remove-to-bundle");

    $(window.mfrBundle.reverse()).each((i, e) => {
      if (e.id == variantID) {
        window.mfrBundle.splice(i, 1);
        return false;
      }
    });
    window.mfrBundle.reverse();

    indicator.text(parseInt(indicator.text()) - 1);
    if (parseInt(indicator.text()) <= 0) indicatorWrapper.hide();

    $(document).trigger("mfr-bundle:product-removed", {
      element: parent,
      quantity: indicator.text(),
    });

    $(document).trigger("mfr-bundle:bundle-changed", [
      {
        remove: variantID,
      },
    ]);

    this.removeVisualizerAccentImage(variantID);
  }

  __handleBundlerClick(e) {
    if (
      $(e.target).hasClass("add-to-cart") ||
      $(e.target).closest(".add-to-cart").length > 0
    )
      return;

    this.$submit.click();
  }

  __handleRemoveBundleFromCart(e) {
    const $button = $(e.currentTarget);
    const bundleHash = $button.attr("data-mfr-remove-bundle"); //dont use data(), it will not work if rivets doesnt bind the data and just added attribute to the html
    const items = CartJS.cart.items;
    let productsToRemove = {};

    //get all key with same properties._bundle_hash
    $.each(items, (index, item) => {
      const itemBundleHash = item.properties._bundle_hash;
      if (itemBundleHash == bundleHash) {
        productsToRemove[item.key] = 0;
      }
    });

    $(".cart-form").addClass("loading");
    this.processRemove(items, bundleHash);
    this.resetProductCards();
  }

  __handleLimitSwitchClick(e) {
    const beforeLimit = this.limit;
    $(e.currentTarget)
      .closest(this.selectors.limitSwitchWrapper)
      .find(this.selectors.limitSwitch)
      .removeClass("is-active");
    $(e.currentTarget).addClass("is-active");
    this.limit = $(e.currentTarget).data("mfr-limit-switch");
    this.minimumProducts = $(e.currentTarget).data("mfr-min-switch");
    // this.minimumProducts = $( `.is-active${ this.selectors.limitSwitch }` ).data( "mfr-limit-switch" );
    // this.limit = $( `.is-active${ this.selectors.limitSwitch }` ).data( "mfr-limit-switch" );

    if (beforeLimit > this.limit && window.mfrBundle.length > this.limit) {
      const elementsToRemove = Math.abs(window.mfrBundle.length - this.limit);
      const startingIndex = window.mfrBundle.length - elementsToRemove;
      const removedProducts = window.mfrBundle.splice(
        startingIndex,
        beforeLimit
      );
      this.removeIndicators(removedProducts);
    }

    $(document).trigger("mfr-bundle:bundle-changed");
    this.updateItems();
    // this.resetBundler();
    // this.updateVisualizer();
    // this.resetIndicators();
  }

  resetIndicators(products) {
    $.each(products, (i, product) => {
      const card = $(`[data-bundle-product-card="${product.id}"]`);
      const indicatorWrapper = card.find(this.selectors.countIndicatorWrapper);
      const indicator = card.find(this.selectors.countIndicator);
      indicator.text(parseInt(indicator.text()) - 1);
      if (parseInt(indicator.text()) <= 0) indicatorWrapper.hide();
      $(document).trigger("mfr-bundle:product-removed", {
        element: card,
        quantity: indicator.text(),
      });
    });
  }

  resetIndicators() {
    const parent = $(this.selectors.productCard);
    const indicatorWrapper = parent.find(this.selectors.countIndicatorWrapper);
    const indicator = parent.find(this.selectors.countIndicator);

    indicatorWrapper.hide();
    indicator.text(0);
    $(document).trigger("mfr-bundle:reset");
  }

  resetAccentImages() {
    const ingredientContainer = $(`${this.selectors.accentImageContainer}`);

    gsap.to(
      $(ingredientContainer).find(".mix-and-match__floating-ingredient"),
      {
        stagger: 0.05,
        opacity: 0,
        onComplete: () => {
          ingredientContainer.empty();
        },
      }
    );
  }

  updateLimit() {
    const limitSwitch = this.$element.find(this.selectors.limitSwitch);
    if (!limitSwitch.length) return;

    this.minimumProducts = $(`.is-active${this.selectors.limitSwitch}`).data(
      "mfr-min-switch"
    );
    this.limit = $(`.is-active${this.selectors.limitSwitch}`).data(
      "mfr-limit-switch"
    );
  }

  // updateVisualizer() {
  //   $( this.selectors.bundlerVisualizerWrapper ).each( ( i, e ) => {
  //     const visualizers = $( e ).find( this.selectors.bundlerVisualizer );
  //     const state = Flip.getState( visualizers );
  //     const wrapperState = Flip.getState( $( e ) );

  //     visualizers.removeClass( "show" );
  //     visualizers.each( ( index, element ) => {
  //       if( index <= this.limit - 1 ) $( element ).addClass( "show" );
  //     } );

  //     Flip.from( state, {
  //       scale: true,
  //       absoluteOnLeave: false,
  //       stagger: 0.4,
  //       ease: "back",
  //       onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1, duration: 0.4}),
  //       onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0, duration: 0.4})
  //     } );

  //     Flip.from( wrapperState, {
  //       duration: .4,
  //       scale: true
  //     } );
  //   } )
  // }

  processRemove(items, hash) {
    let foundObject = items.find(
      (object) => object.properties._bundle_hash == hash
    );
    let payload = {};
    payload[foundObject.key] = 0;

    if (foundObject) {
      $.ajax({
        type: "POST",
        url: window.Shopify.routes.root + "cart/update.js",
        data: {
          updates: payload,
        },
        dataType: "json",
        success: (e) => {
          if (
            e.items.find((object) => object.properties._bundle_hash == hash)
          ) {
            this.processRemove(e.items, hash);
          } else {
            CartJS.getCart();
          }
        },
        error: (e) => {
          console.log("error", e);
        },
      });
    } else {
      CartJS.getCart();
    }
  }

  getBundleQuantity() {
    let quantity = 0;
    if (!Object.keys(window.mfrBundle).length) return quantity;

    $.each(window.mfrBundle, (i, e) => {
      quantity += e.quantity;
    });

    return quantity;
  }

  getBundlePrice() {
    let price = 0;
    if (!Object.keys(window.mfrBundle).length) return price;

    $.each(window.mfrBundle, (i, e) => {
      price += parseFloat(e.price * e.quantity);
    });

    return price;
  }

  getDiscountedPrice() {
    this.$isDiscounted = this.$progressBar.data("threshold-reached");
    let discount = this.$gift.replace("%", "");
    discount = parseInt(discount) ? parseInt(discount) : 0;
    discount = discount / 100;

    if (this.$isDiscounted) {
      return (this.getBundlePrice() - this.getBundlePrice() * discount).toFixed(
        2
      );
    } else {
      return this.getBundlePrice().toFixed(2);
    }
  }

  enableDisableButtons() {
    $(this.selectors.addButton).prop(
      "disabled",
      this.getBundleQuantity() >= this.limit && this.limit > 0
    );
  }

  // BRENDAN –––––– reset and hide indicators and remove buttons
  resetProductCards() {
    $(".bundle-product__count").each(function () {
      $(this).text(0);
      $(this).hide();
    });
    $(".bundle-product__remove").each(function () {
      $(this).hide();
    });
  }
  // BRENDAN END

  changeToRemove(variantID) {
    this.$element
      .find(`[data-mfr-add-to-bundle="${variantID}"]`)
      .removeClass("disabled")
      .removeClass("add")
      .removeAttr("data-mfr-add-to-bundle")
      .addClass("remove")
      .attr("data-mfr-remove-to-bundle", variantID)
      .find(".text")
      .text("Remove");
  }

  changeToAdd(variantID) {
    this.$element
      .find(`[data-mfr-remove-to-bundle="${variantID}"]`)
      .removeClass("disabled")
      .removeClass("remove")
      .removeAttr("data-mfr-remove-to-bundle")
      .addClass("add")
      .attr("data-mfr-add-to-bundle", variantID)
      .find(".text")
      .text("add");
  }

  initBundler() {
    this.$bundler = this.$element.find(this.selectors.bundler);
    this.$submit = this.$element.find(this.selectors.submit);
    this.$subscription = this.$element.find(this.selectors.subscription);

    this.$bundleSection.each((i, e) => {
      const scrollTrigger = ScrollTrigger.create({
        trigger: $(e),
        start: "top center",
        endTrigger: "footer",
        end: "center bottom",
        onEnter: () => this.$bundler.addClass("show"),
        onEnterBack: () => this.$bundler.addClass("show"),
        onLeave: () => this.$bundler.removeClass("show"),
        onLeaveBack: () => this.$bundler.removeClass("show"),
      });
    });

    this.updateItems();

    $(document).on(
      "mfr-bundle:bundle-changed",
      this.__handleBundleChange.bind(this)
    );
    this.$subscription.on("change", (e) => {
      this.updatePrice();
    });

    this.$submit.on("click", this.__handleBundlerSubmit.bind(this));
  }

  __handleBundleChange(e, data) {
    const wrapper = $(this.selectors.bundlerVisualizerWrapper);
    const bundles = window.mfrBundle ?? [];

    wrapper.each((i, wrapper) => {
      const images = $(wrapper).find(this.selectors.bundlerVisualizer);

      images
        .removeClass("is-active")
        .data("variant-id", "")
        .find("img")
        .remove();

      $.each(bundles, (i, bundle) =>
        this.addVisualizerImage(wrapper, bundle["id"])
      );
    });

    this.updateItems();
  }

  addVisualizerImage(wrapper, id) {
    const firstAvailableVisualizer = $(wrapper)
      .find(`${this.selectors.bundlerVisualizer}.show:not(.is-active)`)
      .get(0);

    $(firstAvailableVisualizer)
      .addClass("is-active")
      .data("variant-id", id)
      .append($(`[data-mfr-bundler-visualizer-image='${id}'] img`).clone());
  }

  addVisualizerAccentImage(id) {
    const ingredientContainer = $(`${this.selectors.accentImageContainer}`).get(
      0
    );
    const ingredients = $(
      `[data-mfr-bundler-visualizer-accent-image='${id}']`
    ).children();
    const product = $(
      `[data-mfr-bundler-visualizer-accent-image='${id}']`
    ).closest(".mix-and-match__product");
    const quantity = parseInt(
      $(product).find(this.selectors.countIndicator).text()
    );
    const container = $(
      `<div class='ingredient-cont' data-ingredient='${id}' style="--rotate: ${
        quantity * 20
      }deg"></div>`
    );
    const cloneIngredients = ingredients.clone();

    $(container).append(cloneIngredients);

    $(ingredientContainer).append(container);

    const elements = $(ingredientContainer).find(
      `.mix-and-match__floating-ingredient[data-variant-id='${id}']:not(.visible)`
    );
    gsap.to(elements, {
      duration: 0.03,
      stagger: 0.2,
      opacity: 1,
      onComplete: () => {
        $(elements).addClass("visible");
      },
    });
  }

  removeVisualizerAccentImage(id) {
    const ingredientContainer = $(`${this.selectors.accentImageContainer}`).get(
      0
    );
    const ingredientWrapper = $(ingredientContainer)
      .find(`[data-ingredient='${id}']`)
      .get(0);
    const isIngredientAdded = $(ingredientWrapper).length > 0;

    if (!isIngredientAdded) return;

    const ingredient = $(ingredientWrapper).find(
      ".mix-and-match__floating-ingredient"
    );

    if (isIngredientAdded) {
      gsap.to(ingredient, {
        duration: 0.05,
        stagger: 0.05,
        opacity: 0,
        onComplete: () => {
          ingredient.remove();
          $(ingredientWrapper).remove();
        },
      });
    }
  }

  removeVisualizerImage(id) {
    $(this.selectors.bundlerVisualizerWrapper).each((index, wrapper) => {
      $($(wrapper).find(this.selectors.bundlerVisualizer).get().reverse()).each(
        (i, e) => {
          if ($(e).data("variant-id") == id) {
            $(e)
              .data("variant-id", "")
              .removeClass("is-active")
              .find("img")
              .remove();
            return false;
          }
        }
      );
    });
  }

  resetVisualizerImages() {
    $(this.selectors.bundlerVisualizerWrapper).each((i, wrapper) => {
      if (!$(wrapper).find(this.selectors.bundlerVisualizer).find("img").length)
        return;
      gsap.to($(wrapper).find(this.selectors.bundlerVisualizer).find("img"), {
        stagger: 0.05,
        opacity: 0,
        onComplete: () => {
          $(wrapper)
            .find(this.selectors.bundlerVisualizer)
            .data("variant-id", undefined)
            .removeClass("is-active")
            .find("img")
            .remove();
        },
      });
    });
  }

  addToUpcart(payload) {
    // fetch('/cart/add.js', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({ items: payload }),
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     console.log('Item added:', data);
    //     // Optional: Refresh UpCart to reflect changes
    //     console.log(data);
    //   })
    //   .catch((error) => {
    //     console.error('Error adding item:', error);
    //   });

    CartJS.addItems(payload, function (cart) {
      // Callback function (e.g., update the UI)
      console.log("Cart updated:", cart);
    });
  }

  __handleBundlerSubmit(e) {
    if (this.getBundleQuantity() < this.minimumProducts) return;
    const bundle = window.mfrBundle;
    const bundleHash = this.generateID("mfr-bundle");
    let payload = [];
    let discount = this.$gift.replace("%", "");
    discount = parseInt(discount) || 0;
    discount = this.$isDiscounted ? discount : 0;

    $.each(bundle, (i, e) => {
      let properties = {
        _bundle_discount: discount,
        _bundle_hash: bundleHash,
      };

      let args = {
        id: e.id,
        quantity: e.quantity,
        properties: properties,
      };

      if (payload.filter((item) => item.id == e.id).length)
        payload = payload.map((item) => {
          if (item.id == e.id) {
            item.quantity += e.quantity;
          }

          return item;
        });
      else payload.push(args);
    });

    if (payload.length > 0) {
      this.addToUpcart(payload);
    }

    this.resetBundler();
  }

  updateProgressBar() {
    const bundleItemQuantity = this.getBundleQuantity();
    const threshold =
      parseInt(this.$progressBar.attr("data-progress-threshold"), 10) || 1; // Fallback to 1 to prevent division by 0
    const maximum =
      parseInt(this.$progressBar.attr("data-progress-maximum"), 10) || 1; // Fallback to 1 to prevent division by 0
    const progress = Math.min(100, (bundleItemQuantity / threshold) * 100);
    const quantityLeft = threshold - bundleItemQuantity;
    let progressBarLabel = this.$progressLabel.text();
    let bundlerLabel = this.$bundler
      .find(".progress-bar__logo-label .in-progress")
      .text();
    let labelUpdated = false;

    this.$progressBar.find(".progress-bar__value").css("width", `${progress}%`);

    if (bundleItemQuantity > 0 && bundleItemQuantity <= maximum) {
      this.$progressBar
        .find(".progress-bar__value-counter")
        .text(bundleItemQuantity);
    }

    // Replacing progress bar text with the set threshold
    if (progressBarLabel.indexOf("[quantity]") > -1) {
      progressBarLabel = progressBarLabel.replace(
        "[quantity]",
        `<span class="quantity">${quantityLeft}</span>`
      );
      bundlerLabel = bundlerLabel.replace(
        "[quantity]",
        `<span class="quantity">${quantityLeft}</span>`
      );
      labelUpdated = true;
    }

    // Replacing progress bar gift with the set gift
    if (progressBarLabel.indexOf("[gift]") > -1) {
      progressBarLabel = progressBarLabel.replace(
        "[gift]",
        `<span class="gift">${this.$gift}</span>`
      );
      labelUpdated = true;
    }

    if (labelUpdated) {
      this.$progressLabel.html(progressBarLabel);
      this.$bundler
        .find(".progress-bar__logo-label .in-progress")
        .html(bundlerLabel);
    }

    // Displays progress bar text including remaining items to reach discount
    if (quantityLeft > 0) {
      this.$progressBar.data("threshold-reached", false);
      this.$progressLabel.show();
      // this.$progressLabel.find(".quantity").html(quantityLeft);

      this.$bundler
        .find(".progress-bar__logo-label .in-progress .quantity")
        .html(quantityLeft);
    } else {
      this.$progressBar.data("threshold-reached", true);
      this.$progressLabel.hide();
    }

    if (bundleItemQuantity > 0) {
      this.$progressBar
        .find(".progress-bar__value-counter")
        .css("opacity", "1");
    } else {
      this.$progressBar
        .find(".progress-bar__value-counter")
        .css("opacity", "0");
    }

    if (bundleItemQuantity >= threshold) {
      this.$bundler.find(".progress-bar__logo-label .complete").show();
      this.$bundler.find(".progress-bar__logo-label .in-progress").hide();
    } else {
      this.$bundler.find(".progress-bar__logo-label .complete").hide();
      this.$bundler.find(".progress-bar__logo-label .in-progress").show();
    }
  }

  updateItems() {
    this.updateProgressBar();
    this.updatePrice();
    this.updateRemainingItems();

    console.log("UPDATE");
  }

  updateRemainingItems() {
    const value = this.$submit.find(".quantity").find(".value");
    // const remainingToReachDiscount = parseInt(this.$progressBar.attr("data-progress-threshold"), 10) || 1;
    let remaining = this.minimumProducts - this.getBundleQuantity();
    remaining = remaining < 0 ? 0 : remaining;

    if (remaining == 0) {
      // this.$submit.find('.quantity').hide()
      this.$submit.find(".add-to-cart-text").show();
      this.$submit.removeClass("disabled");
    } else {
      // this.$submit.find('.quantity').show()
      this.$submit.find(".add-to-cart-text").hide();
      this.$submit.addClass("disabled");

      // this.$submit.find(".with-counter [data-mfr-bundler-remaining]")
      // .text(remaining);
    }

    if (this.$isDiscounted) {
      this.$submit.addClass("discounted");
    } else {
      this.$submit.removeClass("discounted");
    }

    this.enableDisableButtons();
    value.text(remaining);
  }

  updatePrice() {
    const oldValue = this.$submit.find(".old-price").find(".value");
    const value = this.$submit.find(".price").find(".value");

    value.text(this.getDiscountedPrice());
    oldValue.text(this.getBundlePrice().toFixed(2));
  }

  generateID(prefix) {
    const timestamp = Date.now().toString(36); // base-36 timestamp
    const random = Math.random().toString(36).substr(2, 5); // random string
    return `${prefix}_${timestamp}_${random}`;
  }

  resetBundler() {
    window.mfrBundle = [];

    // this.$element.find(this.selectors.removeButton).each((i, e) => {
    //   const element = $(e)
    //   const variantID = element.attr('data-mfr-remove-to-bundle')

    //   this.changeToAdd(variantID)
    // })
    // this.$element.find(this.selectors.addButton).removeClass('disabled')
    this.updateItems();
    this.resetProductCards();
    this.resetVisualizerImages();
    this.resetIndicators();
    this.resetAccentImages();
  }
}
